import { BonCommandeReference } from './bonCommandeReference';
import { Employee } from './employee/employee';
import { ModaliteReunion } from './modaliteReunion';
import { Prestation } from './prestation';
import { Service } from './service';
import { Tache } from './tache';
import { TypeEntretien } from './typeEntretien';

export class ActivitePrestation {
	id: number;
	description: string;
	prestation: Prestation;
	tache: Tache;
	intervenant: Employee;
	modaliteReunion: ModaliteReunion;
	chargeTravail: number;
	oldChargeTravail: number;
	dateEntretien: string;
	dateProchainEntretien: string;
	typeEntretien: TypeEntretien;
	dateAffectBdc: string;
	bonCommandeReference: BonCommandeReference;
	cotraitant: boolean = false;
	service: Service;

	constructor(
		options: {
			id?: number;
			description?: string;
			prestation?: Prestation;
			tache?: Tache;
			intervenant?: Employee;
			modaliteReunion?: ModaliteReunion;
			chargeTravail?: number;
			dateEntretien?: string;
			dateProchainEntretien?: string;
			typeEntretien?: TypeEntretien;
			cotraitant?: boolean;
		} = {}
	) {
		this.id = options.id || null;
		this.description = options.description || null;
		this.prestation = options.prestation || new Prestation();
		this.tache = options.tache || new Tache();
		this.intervenant = options.intervenant || new Employee();
		this.modaliteReunion = options.modaliteReunion || new ModaliteReunion();
		this.chargeTravail = options.chargeTravail || null;
		this.dateEntretien = options.dateEntretien || null;
		this.dateProchainEntretien = options.dateProchainEntretien || null;
		this.typeEntretien = options.typeEntretien || new TypeEntretien();
		this.cotraitant = options.cotraitant || false;
	}
}
